import { BsGlobe} from 'react-icons/bs';

const ContactDetails = ({ event }) => (
  <ul className="mb-6 text-xs font-light text-gray-600 leading-6">
    {event.contact.name && (
      <li className="font-semibold text-sm">Promoted by: {event.contact.name}</li>
    )}
    {event.websiteLink && !event.isExpired && (
      <li>
        <a href={event.websiteLink} target="_blank" rel="noreferrer">
          <BsGlobe className="ftext-sm text-theme-alt inline-block mr-2" />
          Website
        </a>
      </li>
    )}
  </ul>
);

export default ContactDetails;
